<div class="secure-shell w-full absolute print-container">
  <div class="secure-header h-12 bg-green-700 flex items-center lg:hidden print-hidden">
    <span class="material-symbols-outlined text-offwhite-500 text-4xl pl-2 cursor-pointer flex-none w-10" id="btnMobileMenu" (click)="menuOpen()">menu</span>
    <div class="flex justify-center grow py-2">
      @if (!isBluebird) {
        <img src="/assets/logowhite.png" class="h-12 py-2"/>
      }
      @if (isBluebird) {
        <img src="/assets/bluebirdlogowhite.png" class="h-12 py-2"/>
      }
    </div>
    <span class="w-10 flex-none"></span>
  </div>
  <div class="secure-main-row flex">
    <app-menu class="secure-menu print-hidden" [menuIsOpen]="menuIsOpen" (menuHasBeenClosed)="menuClosed()"></app-menu>
    <div class="secure-content flex-grow print-auto-height">
      <div class="secure-scroller overflow-y-auto print-overflow print-auto-height" id="scroller">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
